$(document).ready(function () {
    $(".add-wish-list").on('click', function (e) {
        e.preventDefault()
        let login = $(this).data('login')
        let slug = $(this).data('str-book');
        let data = new FormData()

        if (login === false) {
            Cookies.set('almadia_data_wl', slug, {expires: 1})
            Cookies.set('almadia_location-data-wl', window.location, {expires: 1})
            window.location.href = '/login';
        } else {
            data.append('slug', slug)
            $("#div_loading").addClass("loading-almadia");
            sendData(data, '/add-wish-list')
        }
    })

    $(".delete-wl-item").on('click', function (e) {
        e.preventDefault()
        let index = $(this).data("idx")
        let slug = $(this).data('slug')
        let id = $(this).data('wl')
        let data = new FormData()
        data.append('slug', slug)
        data.append('id', id)

        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteItem(data,index)
            }
        })
    })

    function deleteItem(data,index) {
        $("#div_loading").addClass("loading-almadia");
        $.ajax({
            url: "/delete-wish-list-item",
            type: "POST",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                setTimeout(function () {
                    $("#div_loading").removeClass("loading-almadia");
                    if (response.success == "success") {
                        $(".wishlist-item[data-idx='" + index + "']").remove();
                        alertSuccess(response.msg)
                    }
                }, 3000)
            },
            error: function (jqXHR, xhr, status,) {
                console.log("error")
            }
        })
    }

    function sendData(data, route) {
        $.ajax({
            url: route,
            type: "POST",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                setTimeout(function () {
                    $("#div_loading").removeClass("loading-almadia");
                    if (response.success == "success") {
                        alertSuccess(response.msg)
                    }
                }, 3000)
            },
            error: function (jqXHR, xhr, status,) {
                console.log("error")
            }
        })
    }

    window.orders_id = function (value) {
        $.ajax({
            url: window.location.origin + '/mis-pedidos',
            method: 'POST',
            data: {
                "id": value,
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
        })
            .done(function (view) {
                document.getElementById('div_modal').innerHTML = view;
                $("#modal-articles").modal('show')
                /*setTimeout(function () {
                    $('.chosen-select').chosen({width: '100%'});
                }, 300);*/
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });


    }
})
